import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Assignment } from '../../models/assignment.school.model';
import {
  assignmentAdapter,
  AssignmentState,
} from '../reducers/assignment.school.reducer';

export const getAssignmentState =
  createFeatureSelector<AssignmentState>('assignments');
export const getIds = (state: AssignmentState) => state.ids;

export const {
  selectIds: getAssignmentIds,
  selectEntities: getAssignmentEntities,
  selectAll: getAllAssignments,
  selectTotal: getTotalAssignments,
} = assignmentAdapter.getSelectors(getAssignmentState);

export const loading = createSelector(
  getAssignmentState,
  (assignmentState: AssignmentState) => assignmentState.loading,
);

export const inProgress = createSelector(
  getAssignmentState,
  (assignmentState: AssignmentState) => assignmentState.inProgress,
);

export const getAssignmentsByGroup = (groupId: string | null) =>
  createSelector(getAllAssignments, (allItems) => {
    if (!allItems || !groupId) return [];
    return allItems.filter((item) => {
      return item.groupId === groupId;
    });
  });

export const getAssignmentsCountForSelectedGroup = (groupId: string | null) =>
  createSelector(getAllAssignments, (allItems) => {
    if (!allItems || !groupId) return 0;
    return allItems.filter((item) => {
      return item.groupId === groupId;
    }).length;
  });

export const getAssignmentsByGrade = ({
  groupId,
  gradeId,
  academicYear,
}: {
  groupId: string | null;
  gradeId: string | null;
  academicYear?: number | null;
}) =>
  createSelector(getAllAssignments, (allItems) => {
    if (!allItems || !groupId || !gradeId || !academicYear) return [];
    return allItems
      .filter((item) => {
        return (
          item.groupId === groupId &&
          item.gradeId === gradeId &&
          item.academicYear === academicYear
        );
      })
      .sort(sortDescendingByCreatedDate);
  });

export const getAssignmentById = ({
  groupId,
  assignmentId,
  academicYear,
}: {
  groupId: string | null;
  assignmentId: string | null;
  academicYear: number | null | undefined;
}) =>
  createSelector(getAllAssignments, (allItems) => {
    if (!groupId || !academicYear || !assignmentId) return null;
    return allItems.find((item) => {
      return (
        item.groupId === groupId &&
        item.id == assignmentId &&
        item.academicYear === academicYear
      );
    });
  });

function sortDescendingByCreatedDate(a: Assignment, b: Assignment): number {
  return a.created! > b.created! ? -1 : a.created! < b.created! ? 1 : 0;
}
